import {
  CartItemsBody,
  bulkDownloadCreatedSchema,
  cartListSchema,
} from './schemas';

import { useApiClient } from '@/shared/api';

/**
 * v2 장바구니 API (N14 · N15) — 2026-08-08 swagger 확정 반영.
 * 응답은 zod parse로 검증해 계약 어긋남을 런타임에 바로 드러낸다.
 */
export const useV2CartApis = () => {
  const apiClient = useApiClient();
  const domain = 'cart';

  // #region N14 — 장바구니 조회 / 담기 / 빼기 (조회는 FileResponse[] 배열 그대로)
  const getCartAPI = async () =>
    cartListSchema.parse(await apiClient.get<unknown>(domain));

  const postCartItemsAPI = async (body: CartItemsBody) => {
    await apiClient.post(`${domain}/items`, body);
  };

  const deleteCartItemsAPI = async (body: CartItemsBody) => {
    await apiClient.deleteWithBody(`${domain}/items`, body);
  };
  // #endregion

  // #region N15 — 장바구니 ZIP 요청 (N13과 동일한 BulkDownloadCreated 계약)
  // 고른 파일 id만 받는다 — 장바구니 밖 id는 서버가 400 (백엔드 #6 · 2026-10-26)
  const postCartDownloadAPI = async (body: CartItemsBody) =>
    bulkDownloadCreatedSchema.parse(
      await apiClient.post<unknown>(`${domain}/download`, body),
    );
  // #endregion

  return {
    getCartAPI,
    postCartItemsAPI,
    deleteCartItemsAPI,
    postCartDownloadAPI,
  };
};
